export default class Validators {
    static validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static validatePhone(phone) {
        let phoneWithoutSpecialCharacters = phone.replace(/[\.\-\+\(\) ]/g, '');
        var re = /^1?[2-9]{1}[0-9]{9}$/;
        return re.test(phoneWithoutSpecialCharacters);
    }

    static validateReport(report) {
        let re = /^[0-9]{8,10}$/;
        return re.test(report);
    }

    static validateCarat(carat) {
        let re = /([0-9]+(\.[0-9]+)?)/;
        return re.test(carat);
    }

    static validateNumber(num, min = undefined) {
        return !isNaN(num) && ((!min && min !== 0) || num >= min);
    }

    static validateName(name){
        let newName = name.trim();
        return (/^[A-Za-z'\- ]+$/.test(newName) && newName.length > 1);
    }

    static checkUnwantedCharForTextInput(key){
        let regex = /^[a-zA-Z\s]*$/;
        let key_not_permited = !(regex.test(key) || key == 'Enter' || key == 'Shift')
        return key_not_permited
    }

    static checkUnwantedCharForTelInput(key){
        let regex = /[0-9]|-|\(|\)/;
        let key_not_permited = !(regex.test(key) || key == 'Enter' || key == 'Shift')
        return key_not_permited
    }

    static validateDate(day, month, year) {

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month <= 0 || month > 12)
            return false;

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

    static getAge(birthDay, birthMonth, birthYear) {
        return parseInt(Math.floor((Date.now() - (new Date(birthYear, birthMonth-1, birthDay))) / 1000 / 24 / 3600) / 365.242);
    }

    static validateNotEmpty(value){
        return value !== ""
    }
}